export default __webpack_public_path__ + "47689a4c9a543e5da28579b471cba3b0.png";